import { ContentType } from "src/Pages/Company/OrganizationStructure/ConfigureStructure/Tabs/StructureAreas/DataManagment/DataManagment.models";
import {
  downloadAreasData,
  downloadStructureData,
} from "src/Pages/Company/OrganizationStructure/api";

export enum DataSource {
  STRUCTURES = "structures",
  AREAS = "areas",
}

export const handleDownload = async (
  companyId: string,
  structureId: string,
  contentType: ContentType,
  dataSource: DataSource
) => {
  try {
    let fileName: string = "";
    const response = await (dataSource === DataSource.AREAS
      ? downloadAreasData(companyId, structureId, contentType)
      : downloadStructureData(companyId, structureId, contentType));
    const contentDisposition = response.headers["content-disposition"];
    const indexOfSpecialCharacterFileName = contentDisposition.indexOf("''");

    // if file name contains special characters,
    // BE sends two types of file name in content disposition. One with, and one without special characters.
    // If file name doesn't contain special character,
    // BE sends one type of file name in content disposition
    if (indexOfSpecialCharacterFileName !== -1) {
      fileName = decodeURIComponent(
        contentDisposition.substring(contentDisposition.indexOf("''") + 2)
      );
    } else {
      fileName = contentDisposition.substring(
        contentDisposition.indexOf("fileName=") + 9
      );
    }

    const file = await response.data.arrayBuffer();

    const url = URL.createObjectURL(new Blob([file]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", decodeURIComponent(fileName));
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error occurred, couldn't download file: ", error);
  }
};
